import { Flex, Heading } from '@pancakeswap/uikit'
import { DescriptionType } from 'config/FAQ/type'
import { CsText, CsTitle, Image } from '../../../styled'

interface Props {
    detail: DescriptionType[]
}
const DescriptionImage: React.FC<Props> = ({ detail }) => {
    return (
        <Flex width="100%" flexDirection="column" style={{ gap: '3rem' }}>
            {detail?.map((dt) => {
                return (
                    <Flex width="100%" flexDirection="column" style={{ gap: '12px' }}>
                        { dt?.title && 
                            <CsTitle>{dt?.title}</CsTitle>
                        }
                        <Flex flexDirection="column" style={{gap:"12px"}}>
                            { dt?.content?.map((item) => {
                                return (
                                    <CsText>
                                        {item}
                                    </CsText>
                                )
                            })
                                
                            }
                        </Flex>
                        
                        { dt?.image &&
                            <Image src={dt?.image} alt="image description" />
                        }
                    </Flex>
                )
            })}
        </Flex>
    )
}
export default DescriptionImage
